import axios from "axios";

export const logoutApi = async () => {
  try {
    await axios.get(`${process.env.REACT_APP_API_IDENTIFIER}/auth/logout`);
  } catch (err) {
    console.error("err", err);
  }
};
